import { clickHandler } from '@/ui/scripts/analytics/analytics.methods';

const libraryEventName = 'mediaLibrary_tracking';
const filterEventName = 'mediaLibraryFilter_tracking';
const actionPropTitle = 'mediaLibrary_action';
const labelPropTitle = 'mediaLibrary_label';

const elements = [
  ...document.querySelectorAll('.js-media-library-ga .js-document-download-link-ga'),
];
const form = document.querySelector('.js-media-library-form-ga');

function bindClickEventListener(el) {
  el.addEventListener('click', (e) => {
    clickHandler(
      {
        event: libraryEventName,
        actionProp: actionPropTitle,
        labelProp: labelPropTitle,
        action: 'Click',
        label: el.innerText,
      },
      e,
    );
  });
}

function bindFilterEventListener(el) {
  el.addEventListener('submit', (e) => {
    if (determineSelectedFilters(el) === '') {
      e.preventDefault();
      return;
    }
    clickHandler(
      {
        event: filterEventName,
        actionProp: actionPropTitle,
        labelProp: labelPropTitle,
        action: 'Click',
        label: `${determineSelectedFilters(el)}`,
      },
      e,
    );
  });
}

function determineSelectedFilters(el) {
  const fd = new FormData(el);
  let chosenFilters = [];

  for (const pair of fd.entries()) {
    const filterName = pair[0];
    const filterValue = pair[1];
    const select = el.querySelector(
      `select[name="${filterName}"] option[value="${filterValue}"]:not([disabled])`,
    ).innerText;
    chosenFilters.push(select);
  }

  chosenFilters = chosenFilters.join(' - ');

  return chosenFilters;
}

function init() {
  if (!form) {
    return;
  }

  bindFilterEventListener(form);

  if (!elements.length) {
    return;
  }

  elements.forEach(bindClickEventListener);
}

export default init;
